import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { PreLoginRoutingModule } from 'src/routes/pre-login.routing.module';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        PreLoginRoutingModule
    ]
})
export class PreLoginModule {
    
}